export default __webpack_public_path__ + "static/x-logo-black-c9d69acfaf852c0ddb7134208d703501.png";